// extracted by mini-css-extract-plugin
export default {"root":"PowerTranzPaymentResult_root__bwT3U"};